import { io } from "socket.io-client";

// Wrapper singleton de Socket.IO compartilhado entre features.
// CRITICAL: o backend escuta em /api/socket.io/ (nginx só faz proxy_pass
// de /api/* pro Express). Se passar a URL com path '/api', o socket.io
// interpreta como NAMESPACE — conecta no root e bate em 404. Por isso
// passamos a origem e definimos `path` explicitamente.
// withCredentials envia o cookie JWT no handshake.

let socket = null;

export function getSocket() {
    if (!socket) {
        socket = io(window.location.origin, {
            path: "/api/socket.io/",
            withCredentials: true,
            transports: ["websocket", "polling"],
        });
        socket.on("connect", () => console.log("[Socket] conectado"));
        socket.on("disconnect", () => console.log("[Socket] desconectado"));
    }
    return socket;
}

// Helpers que disparam eventos `join-<tipo>` / `leave-<tipo>` no backend.
// O backend (index.js) tem handlers nomeados (join-envio, join-ops,
// join-automacao, etc.) com boundary check por empresa_id — não há um
// `join` genérico. Por isso esta API recebe o tipo separado do logId.

export function joinRoom(tipo, id) {
    const s = getSocket();
    s.emit(`join-${tipo}`, id);
}

export function leaveRoom(tipo, id) {
    const s = getSocket();
    s.emit(`leave-${tipo}`, id);
}
